import React from 'react'
import { ErrorIcon, StatusText, ScannerStatusContainer } from './ScannerErrored.style'

const ScannerErrored = ({ text }: { text: string }) => {
    return (
        <ScannerStatusContainer>
            <ErrorIcon className="wemolo-cross-circle" />

            <StatusText>{text}</StatusText>
        </ScannerStatusContainer>
    )
}

export { ScannerErrored }
